module.exports = __webpack_public_path__ + "f.no2.d4a9edf3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/f.no2.jpg
// module id = S87O
// module chunks = 0